import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Employees from '../pages/Employees';
import Login from '../pages/Login';
import LeaveManagementPage from '../features/leaves/LeaveManagementPage';
import NewLeave from '../pages/NewLeave';
import Payroll from '../pages/Payroll';
import Payslip from '../pages/Payslip';
import EmployeeForm from '../pages/EmployeeForm';
import AttendancePage from '../features/attendance/AttendancePage';
import MainLayout from '../layout/MainLayout';
import SettingsPage from '../features/settings/pages/SettingsPage';


const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/employees" element={<Employees />} />
    <Route path="/employees/add" element={<EmployeeForm />} />
    <Route path="/employees/edit/:id" element={<EmployeeForm />} />
    <Route path="/attendance" element={<MainLayout><AttendancePage /></MainLayout>} />
    <Route path="/leaves" element={<MainLayout><LeaveManagementPage /></MainLayout>} />
    <Route path="/leaves/new" element={<MainLayout><NewLeave /></MainLayout>} />
    <Route path="/payroll" element={<MainLayout><Payroll /></MainLayout>} />
    <Route path="/payroll/:month" element={<MainLayout><Payslip /></MainLayout>} />
    <Route path="/settings" element={<MainLayout><SettingsPage /></MainLayout>} />
    <Route path="*" element={<Navigate to="/dashboard" />} />
  </Routes>
);

export default AppRoutes;
